import AttendanceModule from "./attendanceModule";
import AttendanceSagas from "./redux/attendanceSagas";
import AttendanceReducer from "./redux/attendanceReducer";

export default {
  Component: AttendanceModule,
  moduleName: "attendance",
  saga: AttendanceSagas(),
  reducer: AttendanceReducer
};
